export default "__VITE_ASSET__wFIAJ_rD__"